<!-- 定时群发管理 -->
<template>
<div>
	<!-- 标题 -->
	<div class="page-title">定时群发管理</div>
	
	<div style="display: flex;align-items: center;flex-wrap: wrap;margin: 10px 0 0;">
		<div class="screen-box">
			<div class="screen-label">实际推送时间</div>
			<a-range-picker 
			style="width:300px;" 
			@change="onChangeDate" 
			:locale="locale" 
			:value="[startTime,endTime]" 
			allowClear/>
		</div>
		
		<div class="screen-box">
			<div class="screen-label">设定时间</div>
			<a-range-picker
				style="width:330px;"
				:locale="locale" 
			    :show-time="{ format: 'HH:mm:ss' }"
			    format="YYYY-MM-DD HH:mm:ss"
			    :placeholder="['开始时间', '结束时间']" 
			    @change="onChangeDateC"
			    @ok="onDateC_ok" 
			/>
		</div>
		
		<div class="screen-box">
			<div class="screen-label">图文消息名称</div>
			<a-input v-model="r_name" allowClear placeholder="请输入" style="width: 200px;"/>
		</div>
		
		<div class="screen-box">
			<div class="screen-label">书城</div>
			<a-select
				show-search
				allowClear
			    style="min-width: 200px"
			    placeholder="请选择书城"
			    @change="handleChangeB"
				:filter-option="filterOption"
				:getPopupContainer="getsPopupContainer"
			  >
			    <a-select-option v-for="(item,index) in bookList" :key="index" :value="item.key">
			      {{item.label}}
			    </a-select-option>
			</a-select>
		</div>
		
		<div class="screen-box">
			<div class="screen-label">公众号</div>
			<a-select
				show-search
				allowClear
				notFoundContent="← 请先选择: 书城" 
			    style="min-width: 200px"
			    placeholder="请选择公众号"
			    @change="handleChangeA"
				:filter-option="filterOption"
				:getPopupContainer="getsPopupContainer"
			  >
			    <a-select-option v-for="(value,key) in gzhSelect" :key="key" :value="key">
			      {{value}}
			    </a-select-option>
			</a-select>
		</div>
		
		<div class="screen-box">
			<div class="screen-label">状态</div>
			<a-select
				show-search
				allowClear
			    style="width: 200px"
			    placeholder="请选择状态"
			    @change="handleChangeD"
				:filter-option="filterOption"
				:getPopupContainer="getsPopupContainer"
			  >
			    <a-select-option :value="0">待进行</a-select-option>
				<a-select-option :value="1">成功</a-select-option>
				<a-select-option :value="2">失败</a-select-option>
				<a-select-option :value="3">进行中</a-select-option>
			</a-select>
		</div>
		
		<a-button class="screen-box" @click="searchButton('button')" :loading="search_button_loading" type="primary" icon="search">搜索</a-button>
	
		<div class="screen-box">
			<a-dropdown-button @click="handleButtonClick">
			    批量操作
				<a-menu slot="overlay" @click="handleMenuClick">
					<a-menu-item key="1"> <a-icon type="align-right" />批量取消（已选{{selectedData.length}}项）</a-menu-item>
					
				</a-menu>
			</a-dropdown-button>
		</div>
	</div>
	
	<div>
		<!-- 表头 -->
		<div class="table-th" :style="{'width': table_scroll_width + 'px'}">
			<div class="table-th-cell"
			:style="{'width':30 + 'px'}">
				<a-checkbox :indeterminate="indeterminate" :checked="checkAll" @change="onCheckAllChange"></a-checkbox>
			</div>
			
			<div  v-for="(item,index) in rableTitle" :key="index" >
				<div class="table-th-cell" 
				:style="{'width':item.width + 'px',}">
					{{item.title}}
				</div>
			</div>
		</div>
		
		<!-- 表格内容 -->
		<div v-for="(item,index) in tableShowData" :key="index" class="table-td"  :style="{'width': table_scroll_width + 'px'}">
			<!-- 选择 -->
			<div class="table-td-cell" :style="{'width':30 + 'px'}">
				<a-checkbox :checked="item.checked" @change="onChangeCheckbox($event,index)"></a-checkbox>
			</div>
			
			<template v-for="(z_tem,z_ndex) in rableTitle">
				<div v-if="z_tem.type != 'status' && z_tem.type != 'cz'" class="table-td-cell"
				:style="{'width':rableTitle[z_ndex].width + 'px'}">
					{{item[z_tem.type]}}
				</div>
				<div v-else-if="z_tem.type == 'status'" class="table-td-cell"
				:style="{'width':rableTitle[z_ndex].width + 'px'}">
					{{item.status | statusFilter}}
					<a-tooltip v-if="item.remark" placement="top">
						<template slot="title">
						  <span>{{item.remark}}</span>
						</template>
						<a-icon type="question-circle" style="cursor: pointer;"/>
					</a-tooltip>
				</div>
				<div v-else-if="z_tem.type == 'cz'" class="table-td-cell"
				:style="{'width':rableTitle[z_ndex].width + 'px'}">
					<div v-if="item.status == 0" @click="tabHandle(1,item)" style="color: #62a8ea;cursor: pointer;">取消</div>
				</div>
			</template>
			
		</div>
		
		
		<!-- 表格内容为空时显示 -->
		<div v-show="tableShowData.length == 0" style="text-align: center;text-align:center;padding: 80px 0 50px;"
		:style="{'width': table_null_width + 'px'}">
			<a-icon style="font-size: 70px;color: #999;" type="file-search" />
			<div style="color: #999;font-size: 16px;margin-top: 20px;">内容为空</div>
		</div>
	</div>
	
	<!-- 分页 -->
	<pagingCompont :table_scroll_width="table_scroll_width" :table_null_width="table_null_width"
	:r_page="r_page" :r_limit="r_limit" :table_total="table_total"
	@pagination-Change="paginationChange" @change-size-limit="changeSizeLimit"></pagingCompont>
	
	<!-- 批量取消操作的失败提示 -->
	<a-modal v-model="send_err_visible" width="600px" title="批量取消操作失败内容" @ok="send_err_visible = false" okText="确认" cancelText="取消" >
	    <div style="max-height:500px;overflow-y: overlay;">
			<!-- 表头 -->
			<div class="table-th" style="top: 0;">
				<div  v-for="(item,index) in err_tableTitle" :key="index" >
					<div class="table-th-cell" 
					:style="{'width':item.width + 'px',}">
						{{item.title}}
					</div>
				</div>
			</div>
			
			<!-- 表格内容 -->
			<div v-for="(item,index) in sendErrData" :key="index" class="table-td" >
				<template v-for="(z_tem,z_ndex) in err_tableTitle">
					<div class="table-td-cell"
					:style="{'width':err_tableTitle[z_ndex].width + 'px'}">
						{{item[z_tem.type]}}
					</div>
				</template>
				
			</div>
	    </div>
	</a-modal>
	
	<!-- 加载中 -->
	<div class="loading-box" v-show="search_button_loading">
		<a-spin size="large" />
	</div>
</div>
</template>

<script>
import locale from 'ant-design-vue/es/date-picker/locale/zh_CN';
import moment from 'moment';
import 'moment/locale/zh-cn';

import { massSendTask, pitcherLogList, gzhGroupTask, materialChannelSelect, wxMaterialSelect, massSendTaskCancel } from '@/request/api'	
export default {
	name: 'massManage_',
	components: {
		
	},
	data() {
		this.dateFormat = 'YYYY-MM-DD'
		return {
			locale,
			moment,
			startTime: '2022-06-12',
			endTime: '2022-06-23',
			r_send_start_date: null,
			r_send_end_date: null,
			// 表格部分内容
			// 表格的表头，规定宽度和要用的其他信息
			rableTitle: [
				// {title:"定时任务名称", width:200, type:"local_message_name", },
				// {title:"书城", width:100, type:"channel_name", },
				{title:"公众号", width:110, type:"gzh_name", },
				{title:"图文消息名称", width:210, type:"local_message_name", },
				{title:"定时时间", width:150, type:"send_time", },
				{title:"用户标签", width:150, type:"tag_name", },
				{title:"状态", width:90, type:"status", },
				
				{title:"微信发文返回状态", width:120, type:"wechat_status", },
				{title:"发送总人数", width:100, type:"filter_count", },
				{title:"发送成功人数", width:100, type:"success_count", },
				{title:"发送失败人数", width:100, type:"fail_count", },
				
				{title:"操作", width:70, type:"cz", },
				{title:"创建时间", width:140, type:"created_at", },
			],
			tableShowData: [],
			table_scroll_width: 1000,
			table_null_width: 1000,
			
			search_button_loading: false,
			
			r_page: 1, // 页数
			r_limit: 30, // 每页多少条
			table_total: 0, // 表格内容总数
			
			
			r_type: "", // 历史操作数据下拉类型
			
			r_status: undefined, // 状态
			r_channel_id: undefined, // 渠道
			r_gzh_id: undefined, // 公众号
			r_name: null, // 模板名字
			
			bookList: [], // 渠道下拉
			gzhSelect: [], // 公众号下拉
			
			// 多选
			indeterminate: false,
			checkAll: false,
			selected_number: 0, // 已选数量
			selectedData: [], // 选中的数据
			
			// 批量取消操作-失败提示
			send_err_visible: false,
			sendErrData: [],
			err_tableTitle: [
				{title:"ID", width:110, type:"id", },
				{title:"失败信息", width:330, type:"msg", },
			],
		}
	},
	mounted() {
		let that = this
		that.search_button_loading = true
		
		// 获取表格信息
		let body_width = document.body.clientWidth - 60 - 50 - 190 // 筛选条件大盒子的宽度
		let nn = 0
		that.rableTitle.forEach((res,index)=>{
			nn = nn + res.width
		})
		let table_width = 0
		// 表格宽度小于屏幕的可视宽度减去两边的内边距，并且差距要在100px以上
		if(nn < body_width && body_width - nn > 50){ // 当表格内容不足以沾满一屏时，要适配成一屏
			// console.log("适配")
			that.rableTitle.forEach(res=>{ // 针对表格每一项的宽度进行适配
				res.width = Math.round((res.width/nn)*(body_width)) // 这里减是为了避免res.width值的总和会超过body_width进行的微调，不-10问题应该也不大
			})
			table_width = body_width
		}
		else { // 表格宽度大于等于屏幕可视宽度
			// console.log("不适配")
			table_width = nn
		}
		that.table_scroll_width = table_width + 30
		that.table_null_width = table_width
		
		// 获取7天前日期
		that.startTime = this.moment(this.$getBeforeDay(6), this.dateFormat)
		// 获取当前日期
		that.endTime = this.moment(this.$getThisDay(), this.dateFormat)
		
		materialChannelSelect().then(res=>{
			console.log("下拉",res);
			that.selectData = res.data.data
			let c_data = res.data.data.channel
			let show_data = []
			for (let key in c_data) {
				let ooo = {
					key,
					label: c_data[key],
					status: false,
				}
				show_data.push(ooo)
			}
			// show_data[0].status = true
			that.bookList = show_data
			console.log("show_data",show_data);
		})
		
		// 修改母页面的tab高亮状态
		setTimeout(()=>{
			that.$bus.$emit("tabPath", that.$route.fullPath);
		},300)
		
		that.searchButton()
	},
	methods: {
		// 日期选择
		onChangeDate(date, dateString) {
			// console.log(date, dateString);
			if(dateString[0]){
				this.startTime = this.moment(dateString[0],  this.dateFormat)
				this.endTime = this.moment(dateString[1],  this.dateFormat)
			}
			else {
				this.startTime = null
				this.endTime = null
			}
			
		},
		onChangeDateC(value, dateString){
			this.r_send_start_date = dateString[0] || null
			this.r_send_end_date = dateString[1] || null
		},
		onDateC_ok(value){
			// console.log('onOk: ', value);
		},
		// 给ant design的select选择器重新设置定位
		getsPopupContainer(triggerNode){
			// console.log("getsPopupContainer",triggerNode)
			return triggerNode.parentNode || document.body;
		},
		filterOption(input, option) {
		    return (
		        option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
		    );
		},
		// 公众号
		handleChangeA(value) {
			console.log(value)
			this.r_gzh_id = value 
		    
		},
		// 书城
		handleChangeB(e){
			this.r_channel_id = e
			this.search_button_loading = true
			this.getGzhSelect(e)
		},
		// 状态
		handleChangeD(e){
			this.r_status = e
		},
		// 根据渠道获取公众号
		getGzhSelect(e){
			let that = this
			wxMaterialSelect({
				channel_id: e
			}).then(res=>{
				that.search_button_loading = false
				
				if(res.data.code == 401){ // 未登录
					localStorage.removeItem("access_token");
					that.$router.replace({name: 'login',params: {type:'not_log'}})
					return
				}
				
				console.log("根据渠道获取公众号",res);
				that.gzhSelect = res.data.data.list
			})
		},
		
		// 搜索
		searchButton(type){
			let that = this
			
			if(!that.startTime && !that.r_send_start_date){
				that.$message.warning("至少选择一个日期")
				return
			}
			
			that.search_button_loading = true
			
			if(type == 'button'){
				that.r_page = 1
			}
			
			let r_data = {
				// start_date: moment(that.startTime).format('YYYY-MM-DD') + ' 00:00:00',
				// end_date: moment(that.endTime).format('YYYY-MM-DD') + ' 23:59:59',
				send_start_date: that.r_send_start_date,
				send_end_date: that.r_send_end_date,
				
				page: that.r_page,
				limit: that.r_limit,
				status: that.r_status,
				channel_id: that.r_channel_id,
				gzh_id: that.r_gzh_id,
				name: that.r_name
			}
			if(that.startTime){
				r_data.start_date = moment(that.startTime).format('YYYY-MM-DD') + ' 00:00:00'
			}
			if(that.endTime){
				r_data.end_date = moment(that.endTime).format('YYYY-MM-DD') + ' 23:59:59'
			}
			
			massSendTask(r_data).then(res=>{
				console.log("gzhGroupTask",res)
				that.search_button_loading = false
				that.table_total = res.data.data.total
				if(res.data.code == 0 || res.data.code == 200 || res.data.code == 8011){
					that.$message.success('搜索成功');
					let data = res.data.data.data
					data.forEach(res=>{
						res.checked = false
					})
					that.tableShowData = data
					
					// 重置。目前的多选不支持跨分页选
					that.selectedData = []
					that.indeterminate = false
					that.checkAll = false
				}
				else {
					if(res.data.code == 401){ // 未登录
						localStorage.removeItem("access_token");
						that.$router.replace({name: 'login',params: {type:'not_log'}})
					}
					else {
						that.$message.error(`其他错误：${res.data.msg}`);
					}
				}
			})
		},
		// 分页
		paginationChange(e){
			let that = this
			this.r_page = e
			that.searchButton()
		},
		changeSizeLimit(e){
			// console.log('每页多少条',e)
			this.r_limit = e
			this.searchButton('button')
		},
		
		tabHandle(type,item){
			console.log("item",item);
			let that = this
			if(type == 1){ // 取消操作
				massSendTaskCancel({
					id: item.id
				}).then(res=>{
					console.log("取消操作",res);
					if(res.data.code == 0 || res.data.code == 200 || res.data.code == 8011){
						that.$message.success('操作成功');
						that.searchButton()
					}
					else {
						if(res.data.code == 401){ // 未登录
							localStorage.removeItem("access_token");
							that.$router.replace({name: 'login',params: {type:'not_log'}})
						}
						else {
							that.$message.error(`错误：${res.data.msg}`);
						}
					}
				})
			}
		},
		
		// 多选测试
		onChangeCheckbox(checkedList,index) {
			let that = this
			if(that.tableShowData[index].checked){ // 为选中状态，然后要改为未选中状态
				that.tableShowData[index].checked = false
				
				let iii
				console.log("that.tableShowData[index].id",that.tableShowData[index].id)
				that.selectedData.forEach((res,index_z)=>{
					
					if(res.id == that.tableShowData[index].id){
						iii = index_z
					}
				})
				that.selectedData.splice(iii,1)
				console.log("iii",iii)
			}
			else { // 未选中状态改为选中状态
				that.tableShowData[index].checked = true
				if(that.selectedData.length === 0){
					that.selectedData.push(that.tableShowData[index])
				}
				else {
					// 判断有没有重复的内容，如果里面已经有重复的内容了，就不用再传了
					let ddd = true
					for(let i = 0; i < that.selectedData.length; i++){
						if(that.selectedData[i].id === that.tableShowData[index].id){
							ddd = false
							break;
						}
					}
					if(ddd){
						that.selectedData.push(that.tableShowData[index])
					}
				}
			}
		    // that.tableShowData[index].checked = !that.tableShowData[index].checked
			console.log("that.selectedData",that.selectedData)
			let ccc = true 
			let iii = false
			let nnn = that.selectedData.length || 0
			console.log("that.selectedData.length",that.selectedData.length);
			that.tableShowData.forEach(res=>{
				if(res.checked){
					iii = true
					// nnn = nnn + 1
					
				}
				if(!res.checked){
					ccc = false
				}
			})
			// console.log("nnn",nnn)
			if(ccc){
				that.indeterminate = false
			}
			else {
				that.indeterminate = iii
			}
			that.checkAll = ccc
			that.selected_number = nnn
		},
		// 全选
		onCheckAllChange(e) {
			let that = this
			if(that.checkAll){
				that.tableShowData.forEach(res=>{
					res.checked = false
				})
				that.checkAll = false
				// that.selected_number = 0
				
				that.selectedData = [] // 取消全选的时候，全部清除
			}else {
				that.tableShowData.forEach(res=>{
					res.checked = true
					// 有重复的就不要传了
					let ddd = true
					that.selectedData.forEach(res_r => {
						if(res_r.id === res.id){
							ddd = false
							console.log("l",ddd)
						}
					})
					
					if(ddd){
						console.log("w",ddd)
						that.selectedData.push(res)
					}
				})
				// that.selected_number = that.tableShowData.length
				that.indeterminate = false
				that.checkAll = true
				
			}
			
		},
		
		// 批量操作
		handleButtonClick(e) {
		    // console.log('click left button', e);
		},
		// 批量操作按钮点击
		handleMenuClick(e) {
		    console.log('click', e);
			let that = this
			if(that.selectedData.length == 0){
				that.$message.warning("请先选择内容")
				return
			}
			
			if(e.key == '1'){ // 批量设置巨量付费2
				let arr = []
				that.selectedData.forEach(res=>{
					arr.push(res.id)
				})
				massSendTaskCancel({
					id: arr
				}).then(res=>{
					console.log("取消操作",res);
					if(res.data.code == 0 || res.data.code == 200 || res.data.code == 8011){
						if(res.data.data.err.length == 0){
							that.$message.success('操作成功');
						}
						else { // 表示有失败的，要把失败的展示出来
							// let send_err = [ // 测试用
							// 	{
							// 		id: "1",
							// 		msg: "非待运行状态,禁止取消"
							// 	},
							// 	{
							// 		id: "2",
							// 		msg: "非待运行状态,禁止取消"
							// 	},
							// ]
							// that.sendErrData = send_err
							that.sendErrData = res.data.data.err
							that.send_err_visible = true
						}
						
						that.searchButton()
					}
					else {
						if(res.data.code == 401){ // 未登录
							that.$message.error(`错误：${res.data.msg}`);
						}
						else {
							that.$message.error(`错误：${res.data.msg}`);
						}
					}
				})
			}
			
		},
	},
	filters: {
		statusFilter(value){
			let vvv
			if(value == 0){
				vvv = "待进行"
			}
			if(value == 1){
				vvv = "发送成功"
			}
			else if(value == 2){
				vvv = "发送失败"
			}
			else if(value == 3){
				vvv = "已取消"
			}
			else if(value == 4){ // 4和3一样，本来没有4的，是后端写错了，还返回4，这里就不删了，避免还有问题
				vvv = "已取消"
			}
			return vvv
		}
	}
}	
</script>

<style scoped>

</style>